"use strict";
exports.__esModule = true;
var angular = require("angular");
var recalc_main_component_1 = require("./main/recalc-main.component");
var recalc_records_component_1 = require("./records/recalc-records.component");
var COMPONENT_NAME = 'smartorg.r6.navs.recalcModal';
var RecalcComponent = /** @class */ (function () {
    function RecalcComponent() {
    }
    RecalcComponent.prototype.$onChanges = function () {
        this.tab = 1;
    };
    RecalcComponent.prototype.showAlert = function (input) {
        this.showAlertService({ input: input });
    };
    RecalcComponent.prototype.switchTab = function (tabId) {
        this.tab = tabId;
    };
    return RecalcComponent;
}());
angular.module(COMPONENT_NAME, [
    recalc_main_component_1["default"],
    recalc_records_component_1["default"],
]).component('recalcModal', {
    template: require('./recalc.component.html'),
    bindings: {
        smartorgApi: '=',
        showAlertService: '&',
        treeObj: '<',
        selectedNode: '<'
    },
    controller: RecalcComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=recalc.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/recalc/recalc.component.js